import { useSetRecoilState } from "recoil";
import {
  incomingChallanItemState,
  incomingHistoryPartyState,
  incomingItemsModalTitleState,
  inventoryEntryPartIdState,
} from "../../utils/atoms/atoms";

interface IIncomingHistoryButton {
  modalId: string;
  modalTitle: string;
  partId: number; // Optional prop for part ID
  partyId: number; // Optional prop for party ID
}

const IncomingHistoryButton = ({
  modalId,
  modalTitle,
  partId = 0,
  partyId = 0,
}: IIncomingHistoryButton) => {
  const setIncomingModalTitle = useSetRecoilState(incomingItemsModalTitleState);
  const setEntryPartId = useSetRecoilState(inventoryEntryPartIdState);
  const setIncomingPartyId = useSetRecoilState(incomingHistoryPartyState);
  const setIncomingChallanItemsId = useSetRecoilState(incomingChallanItemState);

  return (
    <button
      className="styled-btn--dark"
      data-bs-toggle="modal"
      data-bs-target={modalId}
      onClick={() => {
        setEntryPartId(partId || 0); // Set to 0 if identifierId is not provided
        setIncomingPartyId(partyId || 0); // Set to 0 if partyId is not provided
        setIncomingChallanItemsId(0); // Reset challan items ID
        setIncomingModalTitle(modalTitle);
      }}
    >
      View
    </button>
  );
};

export default IncomingHistoryButton;
